import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import VmNetworkAdd from "./VmNetworkAdd";
import VmNetworkUpdate from "./VmNetworkUpdate";

import { DropdownType } from "../../base/CustomDropdown";
import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";

export interface VmNetworkDetailData {
    network_id: string,
    network_name: string,
    network_description: string|null,
    network_type_code: string,
    network_status_code: string,
    share_type_code: string,
    physical_network_name: string,
    vlan_id: number,
    up_yn: boolean,
    external_yn: boolean,
    mtu: number,
    all_availability_zone_yn: boolean,
    project: {
        project_id: string,
        project_name: string
    },
    availability_zone: boolean[],
    subnets:
        {
            subnet_id: string,
            subnet_name: string,
            cidr: string
        }[]
    ,
    create_ts: string,
    update_ts: string
}

export const initVmNetworkDetailData = {
    network_id: "",
    network_name: "",
    network_description: "",
    network_type_code: "",
    network_status_code: "",
    share_type_code: "",
    physical_network_name: "",
    vlan_id: 0,
    up_yn: false,
    external_yn: false,
    mtu: 1500,
    all_availability_zone_yn: true,
    project: {
        project_id: "",
        project_name: ""
    },
    availability_zone: [],
    subnets: [
        {
            subnet_id: "",
            subnet_name: "",
            cidr: ""
        }
    ],
    create_ts: "",
    update_ts: ""
}

export interface VmNetworkData {
    network_id: string,
    network_name: string,
    network_description: string,
    network_type_code: string,
    network_status_code: string,
    share_type_code: string,
    physical_network_name: string,
    vlan_id: number,
    up_yn: boolean,
    external_yn: boolean,
    mtu: number,
    all_availability_zone_yn: boolean,
    project: {
      project_id: string,
      project_name: string
    },
    availability_zones: [],
    subnets: [
      {
        subnet_id: string,
        subnet_name: string,
        cidr: string
      }
    ],
    create_ts: string,
    update_ts: string
  }

export const categoryFilters:ListFilter[] = [
    {
        id: 1,
        name: i18n.t("TOTAL_TEXT"),
        type: "",
        code: "",
        count: 0
    },
    {
        id: 2,
        name: i18n.t("ACTIVE_TEXT"),
        type: "networkStatusCode",
        code: "ACT",
        count: 0
    },
    {
        id: 3,
        name: i18n.t("DOWN_TEXT"),
        type: "networkStatusCode",
        code: "DWN",
        count: 0
    },
    {
        id: 4,
        name: i18n.t("BUILD_TEXT"),
        type: "networkStatusCode",
        code: "BLD",
        count: 0
    },
    {
        id: 5,
        name: i18n.t("ERROR_TEXT"),
        type: "networkStatusCode",
        code: "ERR",
        count: 0
    }
];

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("VM_NETWORK_ADD_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "NETWORK_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "NETWORK_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "NETWORK_SYNC",
        }
    }
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("NETWORK_NAME_TEXT"),
        accessor: "network_name",
        disableSortBy: false,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("EXTERNAL_NETWORK_CONNECT_TEXT"),
        accessor: "external_yn",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value === true ? <StatusStableImg /> : <StatusBlockImg />}</div>)
    },
    {
        Header: i18n.t("NETWORK_ACTIVE_STATE_TEXT"),
        accessor: "up_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <><StatusStableImg style={className.statusImg}/>Up</> : <><StatusBlockImg style={className.statusImg}/>Down</>
                }
            </div>
        )
    },
    {
        Header: i18n.t("STATUS_TEXT"),
        accessor: "network_status_code",
        disableSortBy: true,
        style: {
            width: "100px"
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value === "ACT" ? "#3a8344" : value === "ERR" ? "#e6735c": "#8c8c8c",
            }}>
                {
                    value === "ACT" ? "Active"
                    : value === "DWN" ? "Down"
                    : value === "BLD" ? "Build"
                    : "Error"
                }
            </div>
        )
    },
    {
        Header: i18n.t("SHARE_TYPE_TEXT"),
        accessor: "share_type_code",
        disableSortBy: true,
        style: {
            width: "90px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: 50, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 10,
                backgroundColor: value === "PUB" ? "#66abe8" : value === "PRJ" ? "#92ca6e" : "#b6bfce",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#fff"
            }}>
                {
                    value === "PUB" ? "Public"
                    : value === "PRJ" ? "Personal"
                    : value === "HDN" ? "Hidden"
                    : "None"
                }
            </div>
        )
    },
    {
        Header: i18n.t("PROJECT_NAME_TEXT"),
        accessor: "project.project_name",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("NETWORK_TYPE_TEXT"),
        accessor: "network_type_code",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.greenText}}>{value}</div>)
    },
    {
        Header: i18n.t("VM_NETWORK_VLAN_ID_TEXT"),
        accessor: "vlan_id",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer,...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];

export const vmNetworkAddModalContent = {
    title: i18n.t("VM_NETWORK_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <VmNetworkAdd />,
}

export const vmNetworkUpdateModalContent = {
    title: i18n.t("VM_NETWORK_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <VmNetworkUpdate />,
}

export const VmNetworkTypeDropdownItem:DropdownType[] = [
    {
        value: "FLAT",
        label: "FLAT"
    },
    {
        value: "GENEVE",
        label: "GENEVE"
    }
]

const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}